import commissioningApiClient from '@/http/commissioningApiClient';
import { comApi } from '@/http/api';
import { usePollingStore } from '../stores/pollingStore';
import { useCommissioningDeviceStore } from '../stores/commissioningDeviceStore';
import { PollKey } from '../models/Poll';
import { WIFI_STATUS_INTERVAL_MS } from './constants';

export interface WifiStatusResponse {
    code: number;
    connected: boolean;
    ssid: string;
    connectionType?: 'ethernet' | 'wifi' | 'none' | 'unknown';
    /** Request owner, added locally so another SolShare's response is never used. */
    serialNumber: string;
}

/**
 * Initializes global polling here.
 *
 * This is done at this level so polling is re-initialized when the page is refreshed.
 * It also helps minimise code duplication and unnecessary imports in components
 * (e.g. importing `commissioningApiClient` or `commissioningDeviceStore`
 * when a component only needs the polling to run).
 */
export const initPollings = () => {
    const pollingStore = usePollingStore();
    const commissioningDeviceStore = useCommissioningDeviceStore();

    /**
     * Register the wifi status polling
     */
    pollingStore.register(PollKey.WIFI_STATUS, {
        api: async (): Promise<WifiStatusResponse | undefined> => {
            const serialNumber = commissioningDeviceStore.serialNumber;
            if (serialNumber) {
                const response = await commissioningApiClient.get(comApi.meterWifiStatus(serialNumber));
                return { ...response.data, serialNumber };
            };
        },
        interval: WIFI_STATUS_INTERVAL_MS,
        onError: (error) => {
            console.error('Error fetching wifi status', error);
        },
    });

    /**
     * Other global pollings to be added here
     */
    // TODO: Add other global pollings here
}

/**
 * An easy way to stop all the global pollings
 * But pollingStore.stopAll() can be called in any component if needed too
 */
export const stopPollings = () => {
    const pollingStore = usePollingStore();
    pollingStore.stopAll();
}
